import { useState } from "react";
import { useAuth } from "@/store/AuthStore";
import TitleStyleInline from "@/components/base/TitleStyleInline";

interface SectionTitleProps {
  text: string;
  subtitle?: string;
  editable?: boolean;
  size?: "lg" | "md";
}

// Título con estilo global editable + edición en línea del texto y del estilo (fuente/color/glow).
const SectionTitle = ({ text, subtitle, editable = true, size = "lg" }: SectionTitleProps) => {
  const { profile } = useAuth();
  const [value, setValue] = useState(text);
  const [editing, setEditing] = useState(false);
  const isAdmin = profile?.role === "admin";

  return (
    <div className="mb-4">
      <div className="flex flex-wrap items-center gap-2">
        {editing ? (
          <input
            autoFocus
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={() => setEditing(false)}
            onKeyDown={(e) => e.key === "Enter" && setEditing(false)}
            className={`editable-title min-w-0 flex-1 bg-background-200/60 border border-accent-500/40 rounded-md px-2 py-0.5 outline-none ${
              size === "lg" ? "text-xl md:text-2xl font-bold" : "text-base md:text-lg font-bold"
            }`}
          />
        ) : (
          <h2
            className={`editable-title min-w-0 break-words ${
              size === "lg" ? "text-xl md:text-2xl font-bold" : "text-base md:text-lg font-bold"
            }`}
          >
            {value}
          </h2>
        )}
        {editable && !editing && (
          <button
            onClick={() => setEditing(true)}
            className="w-7 h-7 flex items-center justify-center rounded-md text-foreground-500 hover:text-accent-300 hover:bg-background-200/60 cursor-pointer"
            aria-label="Editar título"
            title="Editar título"
          >
            <i className="ri-pencil-line text-sm" />
          </button>
        )}
        {isAdmin && editable && !editing && <TitleStyleInline />}
      </div>
      {subtitle && <p className="text-xs md:text-sm text-foreground-600 mt-0.5">{subtitle}</p>}
    </div>
  );
};

export default SectionTitle;